/* Predictive search overlay per locked design (Search / Loading · Results · Zero).
   Opens from the header search icon; falls back to /search navigation without JS.
   Strings come from data attributes on the overlay (HP1). */
(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  var trigger = document.getElementById('navSearchIcon');
  if (!overlay || !trigger) return;

  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-search-results]');
  var loading = overlay.querySelector('[data-search-loading]');
  var str = overlay.dataset;
  var searchUrl = overlay.querySelector('form').getAttribute('action') || '/search';
  var debounceTimer = null;
  var activeFetch = 0;

  function setOpen(open) {
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.toggle('search-overlay--open', open); });
    document.documentElement.classList.toggle('nav-drawer-lock', open);
    if (open) {
      setTimeout(function () { input.focus(); }, 60);
    } else {
      setTimeout(function () { if (!overlay.classList.contains('search-overlay--open')) overlay.hidden = true; }, 220);
    }
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    setOpen(true);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-close]') || e.target.classList.contains('search-overlay__scrim')) setOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('search-overlay--open')) setOpen(false);
  });

  function render(html) {
    results.innerHTML = html;
    results.hidden = !html;
    loading.hidden = true;
  }

  function allResultsLink(q) {
    var a = document.createElement('a');
    a.className = 'search-overlay__all';
    a.href = searchUrl + '?q=' + encodeURIComponent(q);
    a.textContent = str.strAll.replace('%q%', q) + ' →';
    return a.outerHTML;
  }

  function query(q) {
    /* Section Rendering API instead of suggest.json: the predictive-search
       section orders results by cart_catalyst.sort_priority in Liquid, which
       the JSON endpoint cannot expose (app brief 2026-09-18 / Gotcha 22). */
    var ticket = ++activeFetch;
    loading.hidden = false;
    fetch(searchUrl + '/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (ticket !== activeFetch) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('[data-predictive-results]');
        render(body ? body.innerHTML : '');
      })
      .catch(function () {
        if (ticket !== activeFetch) return;
        render('<p class="search-overlay__zero-text">' + str.strError + '</p>' + allResultsLink(q));
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    if (q.length < 2) { render(''); loading.hidden = true; return; }
    debounceTimer = setTimeout(function () { query(q); }, 250);
  });
})();
